<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.meeting_turns', 2),
                        href: meta.links.calendar_index,
                    },
                    {
                        name: $tc('messages.students', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.index" method="GET" @submit.prevent="filter" class="p-4" id="student_turns">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 md:grid-cols-12">
                <div class="sm:col-span-6">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.groups')" for="group_ids" />
                        <SlideOverCheckboxInput v-model="form.group_ids" :options="options.groups">
                            <div class="flex justify-end">
                                <div class="mt-1">
                                    <SubmitFormButton
                                        form="student_turns"
                                        :button-text="$t('messages.filter')"
                                        :processing="form.processing"
                                        is-filter
                                    />
                                </div>
                            </div>
                        </SlideOverCheckboxInput>
                        <FormError :value="form.errors.group_ids" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700"> &nbsp; </label>
                    <div class="flex justify-end space-x-2">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>

        <Tabs>
            <Tab :title="group.name" v-for="group in groups" :key="group.id">
                <div class="flex flex-col mt-5">
                    <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                        <div
                            class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                        >
                            <table class="min-w-full divide-y divide-gray-200">
                                <thead>
                                    <tr>
                                        <th
                                            class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            {{ $t('messages.student') }}
                                        </th>
                                        <th
                                            class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            {{ $tc('messages.relatives', 2) }}
                                        </th>
                                        <th
                                            class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            <span class="sr-only">{{ $t('messages.actions') }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                        v-for="(student, index) in group.students"
                                        :key="student.id"
                                    >
                                        <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                            <InertiaLink :href="student.links.show" class="text-indigo-500">
                                                {{ student.full_name }}
                                            </InertiaLink>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                            <div
                                                v-for="turn in student.turns"
                                                :key="turn.id"
                                                class="flex gap-x-2 bg-blue-50 hover:bg-blue-100 p-1"
                                            >
                                                <Tippy v-if="turn.comment">
                                                    <div>
                                                        <IconMessage
                                                            class="w-4 h-4 text-blue-400 inline-block"
                                                            v-if="turn.comment"
                                                        />
                                                    </div>
                                                    <template #content>
                                                        <div>
                                                            <div>{{ $t('messages.comment') }}:</div>
                                                            <div class="pl-2 lg:pl-4 font-light">
                                                                <p>{{ turn.comment }}</p>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </Tippy>

                                                <div>{{ turn.date_display }}</div>

                                                <div class="text-gray-500">
                                                    {{ turn.time_start }} - {{ turn.time_end }}
                                                </div>
                                            </div>
                                            <div
                                                v-for="relative in student.relatives"
                                                :key="relative.id"
                                                class="flex gap-x-2 items-center"
                                            >
                                                <div>
                                                    {{ relative.full_name }}
                                                </div>
                                                <div class="bg-blue-50 hover:bg-blue-100 p-1">
                                                    <div
                                                        v-for="turn in relative.turns"
                                                        :key="turn.id"
                                                        class="flex gap-x-2"
                                                    >
                                                        <div>{{ turn.date_display }}</div>

                                                        <Tippy v-if="turn.comment">
                                                            <div>
                                                                <IconMessage
                                                                    class="w-4 h-4 text-blue-400 inline-block"
                                                                    v-if="turn.comment"
                                                                />
                                                            </div>
                                                            <template #content>
                                                                <div>
                                                                    <div>{{ $t('messages.comment') }}:</div>
                                                                    <div class="pl-2 lg:pl-4 font-light">
                                                                        <p>{{ turn.comment }}</p>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </Tippy>

                                                        <div class="text-gray-500">
                                                            {{ turn.time_start }} - {{ turn.time_end }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">-</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Tab>
        </Tabs>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import SlideOverCheckboxInput from '@/components/Forms/SlideOverCheckboxInput.vue';
import AppButton from '@/components/AppButton.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import Tabs from '@/components/Tabs.vue';
import Tab from '@/components/Tab.vue';
import { IconCalendarEvent, IconMessage } from '@tabler/icons-vue';
import { Tippy } from 'vue-tippy';

export default {
    components: {
        IconMessage,
        Tippy,
        IconCalendarEvent,
        Tab,
        Tabs,
        SubmitFormButton,
        AppButton,
        SlideOverCheckboxInput,
        PanelPage,
        FormLabel,
        FormError,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'groups', 'filters', 'options', 'defaults'],
    data() {
        return {
            form: this.$inertia.form({
                group_ids: this.filters.group_ids,
            }),
        };
    },

    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
